/**
 * Assignment helpers — every task / complaint must have an assignee,
 * and the acting user ("Self") is the default when nobody else is chosen.
 */

export function assigneesOrSelf(ids, selfId) {
  if (Array.isArray(ids) && ids.length > 0) return ids;
  if (selfId == null || selfId === '') return [];
  return [selfId];
}

export function assigneeOrSelf(id, selfId) {
  if (id != null && id !== '') return id;
  if (selfId == null || selfId === '') return null;
  return selfId;
}

export function formatAssigneeLabel(user, selfId) {
  if (!user) return selfId != null ? 'Self' : 'User';
  const name = (
    user.full_name
    || user.label
    || `${user.first_name || ''} ${user.last_name || ''}`.trim()
  ).trim();
  const email = user.email ? `(${user.email})` : '';
  const body = [name, email].filter(Boolean).join(' ');
  const isSelf =
    selfId != null && user.id != null && Number(user.id) === Number(selfId);
  if (isSelf) return body ? `Self — ${body}` : 'Self';
  return body || (user.id != null ? `User ${user.id}` : 'User');
}
